import { Button, Input, Modal, message, Image, Checkbox, Select, Row, Col } from 'antd';
import React, { useEffect, useState } from 'react';
import { Account, ApiCode, Currency, GoogleBindInfo, ServerUserWalletStatus, ServerWalletAddress } from '../data/common';
import Api from '../utils/Api';
import { GlobalUtil } from '../utils/GlobalText';
import { StyleUtils } from '../utils/Style';
import events from '../utils/events';
import { AppEvent, AppMessageType } from '../data/events';
import { UserInfoManager } from '../utils/UserInfoManager';
import { CheckboxValueType } from 'antd/es/checkbox/Group';
import { AntdButton, AntdInput, AntdSelect } from '../views/commonview';

export interface DoubleCheckProps {
    show: boolean
    onClick: (ok: boolean) => void,
    account: Account | null | undefined,
    currency: Currency | null | undefined,
    walletAddress: ServerWalletAddress | null | undefined
}

const SyncWalletAddressView: React.FC<DoubleCheckProps> = (props) => {
    const [loading, setLoading] = useState(false)
    let [syncAccount, setSyncAccount] = useState<string[] | null>([])
    let [code, setCode] = useState("")
    let [userWallets, setUserWallets] = useState<ServerUserWalletStatus[]>([])
    const disable = !syncAccount || !code
    const clear = () => {
        setCode("")
        setSyncAccount([])
        setUserWallets([])
    }
    const loadData = async () => {
        try {
            if (!props.show || !props.account || !props.currency) {
                return
            }
            let res = await Api.getUserWalletState(props.account?.account ?? "", props.currency?.code ?? "")
            if (res.code === ApiCode.SUCCESS) {
                setUserWallets(res.data ?? [])
            }
        } catch (e) {

        }
    }
    useEffect(() => {
        loadData()
    }, [props.show])
    const handleChange = (value: CheckboxValueType[]) => {
        setSyncAccount(value as string[])
    };
    return <Modal
        width={"50%"}
        centered={true}
        maskClosable={false}
        open={props.show}
        maskTransitionName=""
        onCancel={() => {
            clear()
            props.onClick(false)
        }}
        footer={[]}
    >
        <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex", flexDirection: "row", fontWeight: "bold", color: StyleUtils.theme().fontColor_1 }}>{GlobalUtil.t("account.syncPaymentAddress")}</div>
            <div style={{ display: "flex", flexFlow: 'row nowrap', marginTop: StyleUtils.getHeight(15), }}>
                <div style={{ width: "110px", fontSize: StyleUtils.getFont(12), color: StyleUtils.theme().fontColor_1 }}>
                    {props.currency?.name}
                </div>
                <div style={{ flex: '0 1 85%', fontSize: StyleUtils.getFont(12), color: StyleUtils.theme().fontColor_1, maxWidth: "500px", overflow: "hidden",whiteSpace: "nowrap",textOverflow: "ellipsis" }} >
                    {props.walletAddress?.address}
                </div>
            </div>
            <div style={{ display: "flex", flexFlow: 'row nowrap' }}>
                <div style={{ width: "110px", fontSize: StyleUtils.getFont(12), color: StyleUtils.theme().fontColor_1 }}>
                    {GlobalUtil.t("addressFrom")}
                </div>
                <div style={{ flex: '0 1 85%', fontSize: StyleUtils.getFont(12), color: StyleUtils.theme().fontColor_1 }}>
                    {props.walletAddress?.addressDesc}
                </div>
            </div>
            <div style={{ marginTop: StyleUtils.getHeight(10), fontSize: StyleUtils.getFont(13), color: StyleUtils.theme().fontColor_1 }}>{GlobalUtil.t('sync_pay_address')}</div>
            <div style={{ marginTop: StyleUtils.getHeight(8), }}>
                <AntdSelect>
                    <Select value={syncAccount} dropdownRender={() => {
                        return <Checkbox.Group value={syncAccount as CheckboxValueType[]} onChange={handleChange} style={{ width: '100%', display: "flex", flexDirection: "column" }} >
                            {
                                userWallets.flatMap((v, k) => {
                                    let sameAddress = v.currentAddress === props.walletAddress?.address
                                    let disable = sameAddress || !v.status || v.account === props.account?.account
                                    return <div style={{ padding: StyleUtils.getWidth(5), display: "flex", flexDirection: "row" }}>
                                        <Checkbox disabled={disable} value={v.account} style={{ padding: 0 }}>
                                            {v.account}
                                        </Checkbox>
                                        {disable && <div style={{ display: "flex", alignItems: "center", fontSize: StyleUtils.getFont(6), marginLeft: StyleUtils.getWidth(5), color: "red" }}>({sameAddress ? "与以上地址相同" : !v.status ? "有一个地址变更待激活" : "与以上地址相同"})</div>
                                        }
                                    </div>
                                })

                            }
                        </Checkbox.Group>
                    }} onChange={handleChange} mode="multiple" style={{ width: "100%" }} options={userWallets.flatMap((v) => { return { "value": v.account, label: v.account } })} />
                </AntdSelect>
            </div>
            <div style={{ marginTop: StyleUtils.getHeight(10), fontSize: StyleUtils.getFont(13), color: StyleUtils.theme().fontColor_1 }}>{GlobalUtil.t('checkCode')}</div>
            <div style={{ marginTop: StyleUtils.getHeight(8) }}>
                <AntdInput>
                    <Input
                        style={{}}
                        value={code}
                        placeholder={"000000"}
                        onChange={(e) => {
                            setCode(e.target.value.trim())
                        }}
                    />
                </AntdInput>
            </div>

            <div style={{ paddingTop: StyleUtils.getWidth(20), display: "flex", flexDirection: "row" }}>
                <AntdButton>
                    <Button
                        loading={loading} disabled={disable} onClick={async () => {
                            setLoading(true)
                            try {
                                let syncAccounts = ""
                                syncAccount?.forEach((v) => {
                                    if (syncAccounts.length) {
                                        syncAccounts += ","
                                    }
                                    syncAccounts += v
                                })
                                let res = await Api.syncWalletAddress(props.account?.account ?? "", props.currency?.code!!, props.walletAddress?.address!!, syncAccounts ?? "", code)
                                if (res.code === ApiCode.SUCCESS) {
                                    events.emit(AppEvent.SHOW_MESSAGE, {
                                        type: AppMessageType.SUCCESS,
                                        message: GlobalUtil.t("successTip")
                                    })
                                    clear()
                                    props.onClick(true)
                                } else {
                                    events.emit(AppEvent.SHOW_MESSAGE, {
                                        type: AppMessageType.ERROR,
                                        message: res.msg ?? GlobalUtil.t("errorTip")
                                    })
                                }
                            } catch (e) {
                                events.emit(AppEvent.SHOW_MESSAGE, {
                                    type: AppMessageType.ERROR,
                                    message: GlobalUtil.t("errorTip")
                                })
                            }
                            setLoading(false)
                        }} type="primary" style={{ width: "100%" }}>{GlobalUtil.t("confirm")}</Button>
                </AntdButton>
            </div>

        </div>
    </Modal>
}


export default SyncWalletAddressView;